import { FunctionComponent, memo } from 'react';
import { StoryCardArticleContent } from '../../../../services';
import { CardContainer } from '../CardContainer';
import { Content } from '../Content';
import { RightSideStoryCardProps } from '../RightSideStoryCard';

export const Article: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  const { type, content } = card;
  const { title, sourceName, abstract } = content as StoryCardArticleContent;

  return (
    <CardContainer card={card}>
      <Content cardType={type} source={sourceName} title={title} text={abstract} />
    </CardContainer>
  );
});
